import { environment } from 'src/environment';
import { Component, Input, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-guest-header',
  templateUrl: './guest-header.component.html',
  styleUrls: ['./guest-header.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink]
})
export class GuestHeaderComponent implements OnInit {

  @Input() guest;
  logo;

  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, public settingsService: SettingsService) {
  }

  ngOnInit(): void {
  }

}
